<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">申请刻制 / 销毁印章</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form-item label="所属公司">
            <el-select size="small" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
              <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker v-model="form.applyTime" size="small" value-format="yyyy-MM-dd" type="date"
              placeholder="选择申请印章的时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="申请内容">
            <el-radio v-model="form.type" label="0">刻制</el-radio>
            <el-radio v-model="form.type" label="1">销毁</el-radio>
          </el-form-item>
          <el-form-item label="印章名称">
            <el-col :span="10">
              <el-input v-if="form.type==0" placeholder="请输入需要刻制的印章名称" size="small" v-model="form.sealName"></el-input>
              <el-select v-else size="small" class="organization-select" v-model="form.sealId" placeholder="请选择要销毁的印章">
                <el-option v-for="item in sealListData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="印章枚数">
            <el-col :span="10">
              <el-input-number size="small" v-model="form.sealNum" :min="1" :max="10" label=""></el-input-number>
            </el-col>
          </el-form-item>
          <el-form-item label="申请事由">
            <el-input type="textarea" :rows="3" placeholder="请输入申请原因" v-model="form.remark"></el-input>
          </el-form-item>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin:30px 0 -10px 50px;">
            * 意见与审批
          </div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="form.approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="form.approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsers.c1" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>

          <el-form-item label="">
            <el-button @click="createOperate()" v-loading="loading" class="form-btn" type="success">确认提交申请</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import approvalUsers from '@/Mixins/approvalUsers'

  import ApprovalItem from '../../components/ApprovalItem'
  import Attachments from '@/components/Attachments'
  export default {
    computed: {
      ...mapState({
        userData: state => state.main.userData,
        organization: state => state.main.organization,
        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    mixins: [approvalUsers],
    data() {
      return {
        organizationListData: [],
        sealListData: [],
        loading: false,
        form: {
          depId: "",
          type: "0",
          applyTime: "",
          sealId: "",
          sealName: "",
          sealNum: "",
          remark: "",
          approvalType: "0",
          approvalUserIds: "",
        },

        attachmentArr: [],
        applyInfo: '',
      }
    },
    created() {
      this.setSelectArr(this.applyInfo, 1)
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      this.form.applyTime = util.getFormatDate()

      this.getSealListData()

      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
        this.formLoading = true
        this.getApplyInfo()
      }
    },
    components: {
      ApprovalItem,
      Attachments,
    },
    methods: {
      // 获取原审批表内容
      getApplyInfo() {
        ajax.get('/seal/apply/info/', {
          applyId: this.form.applyId,
          type: 1
        }, (res) => {
          this.applyInfo = res.vo

          this.form = this.applyInfo
          this.form.applyId = this.form.flow.applyId

          this.form.applyType = this.form.type
          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, this.applyInfo.type)
          this.formLoading = false
        })
      },
      // 获取列表
      getSealListData() {
        ajax.get('/seal/list', {
          depId: this.form.depId
        }, (res) => {
          this.sealListData = res.vo.array
        })
      },
      // 提交审批
      createOperate() {
        if ((!this.form.sealName && !this.form.sealId) || !this.form.remark) {
          this.$message.error("印章名称和刻制或销毁的原因必填")
          return
        }

        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }

        this.form.attachments = this.$refs.attachments.getAttachments()

        let _url = !this.form.applyId ? '/seal/addordestroy/approval' : '/seal/addordestroy/approval/edit'
        this.loading = true
        ajax.post(_url, this.form, (res) => {
          this.loading = false
          this.$message.success("刻制或销毁印章申请提交成功")
          this.$router.back()
        })
      },
    },
    watch: {
      contactSelectArr() {
        switch (this.userType) {
          case 1:
            this.selectArr1 = this.contactSelectArr
            break;
          case 2:
            this.selectArr2 = this.contactSelectArr
            break;
          case 3:
            this.selectArr3 = this.contactSelectArr
            break;
        }
      },
    },
    // beforeRouteLeave(to, from, next) {
    //   next()
    // },
  };
</script>


// WEBPACK FOOTER //
// src/page/seal/create2.vue